import pino from 'pino';

import { CitOrigin } from './types/cit-public-api';

export const logger = pino({
  level: 'info',
  timestamp: pino.stdTimeFunctions.isoTime,
  transport:
    process.env.NODE_ENV !== 'production'
      ? {
          target: 'pino-pretty',
          options: {
            translateTime: 'HH:MM:ss',
            colorize: true
          }
        }
      : undefined
});

export const getLogger = (citOrigin: string) =>
  logger.child({
    // service refers to HUB vs. HUB Pro here
    service: citOrigin === CitOrigin.HUBPRO ? CitOrigin.HUBPRO : CitOrigin.HUB,
    citOrigin,
    env: process.env.NODE_ENV
  });
